import LinkButton from "./component-library3.mjs";
import Paragraph from "./component-library5.mjs";
import NoAccessIcon from "./component-library263.mjs";
import "./component-library264.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "GdprPermissionLayer",
  components: {
    Paragraph,
    LinkButton,
    NoAccessIcon
  },
  methods: {
    onSettingsReset() {
      var _a, _b;
      (_b = (_a = window.utag) == null ? void 0 : _a.gdpr) == null ? void 0 : _b.showConsentPreferences();
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "gdpr-permission-layer" }, [_c("NoAccessIcon", { staticClass: "gdpr-permission-layer__icon" }), _c("Paragraph", { staticClass: "gdpr-permission-layer__main_copy", attrs: { "text": "Leider können wir diesen Inhalt aufgrund Ihrer Cookie-Einstellungen nicht anzeigen." } }), _c("Paragraph", { staticClass: "gdpr-permission-layer__sub_copy" }, [_vm._v(" Bitte in den "), _c("LinkButton", { staticClass: "gdpr-permission-layer__link", attrs: { "tag": "button", "text": "" }, on: { "click": _vm.onSettingsReset } }, [_vm._v(" Einstellungen ")]), _vm._v(' "Dienste von anderen Unternehmen" aktivieren ')], 1)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "e76b9ba1",
  null,
  null
);
const GdprPermissionLayer = __component__.exports;
export {
  GdprPermissionLayer as default
};
